import React from 'react';
import { observer } from 'mobx-react-lite';

import { FriendshipUserList } from './FriendshipUserList';
import { EmptyResultTypeEnum } from '../views/EmptyResultView';
import { LikesUserList as LikesUserListType } from '@models/Viewer/LikesUserListModel';
import { User } from '@models/Viewer/UserModel';

interface ILikesUserListProps {
  list: LikesUserListType;
  refetch(): Promise<void>;
  fetchMore(): Promise<void>;
  onPress(item: User): void;
  contentContainerStyle?: any;
}

export const LikesUserList = observer<ILikesUserListProps>(
  ({ list, refetch, fetchMore, onPress, contentContainerStyle }) => {
    const isLoading = list.fetch.inProgress && list.isEmpty;

    let emptyResultType: EmptyResultTypeEnum =
      EmptyResultTypeEnum.Error;

    if (list.fetch.isError) {
      emptyResultType = EmptyResultTypeEnum.Error;
    } else if (list.isEmpty) {
      emptyResultType = EmptyResultTypeEnum.NoResult;
    }

    return (
      <FriendshipUserList
        contentContainerSx={contentContainerStyle}
        data={list.asArray}
        onEndReached={fetchMore}
        onRefresh={refetch}
        isRefreshing={list.fetch.inProgress}
        isLoading={isLoading}
        isLoadingMore={list.fetchMore.inProgress}
        onPress={onPress}
        emptyResultType={emptyResultType}
      />
    );
  },
);
